
import { Menu, Notification } from '@/models'
import SignalRService from '@/SignalRService'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { markAsRead } from '../admin/users/users.service'

const AppModule = namespace('app')

@Component
export default class MenuBar extends Vue {
  @AppModule.Getter
  public _messageCount!: () => number

  @AppModule.Action('fetchNotifications') fetchNotifications!: (
    userId: string
  ) => Promise<void>

  @AppModule.Action('stopSignalR') stopSignalR!: () => Promise<void>
  @AppModule.Action('resetStore') resetStore!: () => Promise<void>
  // private signalRService = new SignalRService()

  @AppModule.Getter
  public _messages!: Notification[]

  @AppModule.Getter
  public _getUserInsurances!: () => string

  public showNotificationCenter = false
  private messages = []
  @Prop() data!: Menu[]
  public currentDoctor: string | null = null
  public currentUser = ''
  public message = {
    title: null,
    body: null,
    notificationId: null
  }
  async logout() {
    this.stopSignalR()
    this.clearAllButOne('trusted_device')
    this.resetStore()
    this.$router.push('Login')
  }

  public clearAllButOne(keyToKeep) {
    // 1. Save the value of the key you want to preserve
    const keptValue = localStorage.getItem(keyToKeep)

    // 2. Clear all items from localStorage for the current domain
    localStorage.clear()

    // 3. Restore the preserved key-value pair if it existed
    if (keptValue !== null) {
      localStorage.setItem(keyToKeep, keptValue)
    }
  }

  public showModal(notification: Notification) {
    this.message.title = notification.messageTitle
    this.message.body = notification.messageBody
    this.message.notificationId = notification.notificationID
    this.$root.$emit('bv::show::modal', 'message-modal', '#btnShow')
  }

  async created() {
    // const userId = 5
    this.currentDoctor = JSON.parse(
      JSON.parse(JSON.stringify(localStorage.getItem('currentDoctor')))
    )

    if (localStorage.getItem('currentUser')) {
      const u = localStorage.getItem('currentUser')
      this.currentUser = JSON.parse(u || '{}')
    }
  }
  async mounted() {
    await this.fetchNotifications(this.currentUser.rmtUserId)
    const persistentMessages = this._messages.filter(
      c => c.isPersistent && !c.readFlag
    )
    await this.showPersistentMessages(persistentMessages)
  }

  async showPersistentMessages(messages: Notification[]) {
    messages = messages.filter(c => c.userID_M == this.currentUser.rmtUserId)

    for (const m of messages) {
      const result = await this.$swal.fire({
        title: m.messageTitle,
        text: m.messageBody,
        confirmButtonText: 'Mark as Read',
        allowEnterKey: false,
        allowEscapeKey: true,
        allowOutsideClick: false,
        showDenyButton: true,
        denyButtonText: 'Close'
      })

      if (result.isConfirmed) {
        await this.markAsRead(m.notificationID, m.isPersistent)
      }
    }
  }
  // async mounted() {}
  public showNotifications() {
    this.showNotificationCenter = !this.showNotificationCenter
  }
  public async markAsRead(notificationId: number, persistent = false) {
    await markAsRead(notificationId)
    if (!persistent) {
      this.$root.$emit('bv::hide::modal', 'message-modal', '#btnShow')
    }
    await this.fetchNotifications(this.currentUser.rmtUserId)
  }

  switchDoctor() {
    localStorage.removeItem('currentDoctor')
    localStorage.removeItem('selectedDoctor')
    localStorage.setItem('needsADoctor', 'true')
    this.$router.push({ name: 'DoctorSelection' })
  }
}
